<template>
  <!-- <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-8">
          <strong class="card-title mb-3">Indices Vs Portfolio</strong>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-1">
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
  <div class="card-body">-->
  <div>
    <div class="row mb-15"></div>
    <div class="row mb5">
      <div class="col-md-4">
        <div class="form-group">
          <select class="form-control" name="sector" v-model="selInd" @change="getGroupData">
            <option value>Select Index</option>
            <option
              v-for="(pr, index) in priceVsIndexList"
              :value="index"
              v-bind:key="'group'+index"
            >{{getLabel(pr.Group)}}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <v-select
            :options="companyList"
            :placeholder="'Select Company'"
            :label="'companyname'"
            v-model="selComp"
            @input="getGroupData"
          ></v-select>
        </div>
      </div>
      <div class="col-md-1">
        <!-- <download :tableId="'portfolios-'+selComp.companyname" :fileName="'portfolios-'+selComp.companyname"></download> -->
      </div>
      <div class="col-md-1">
        <div class="form-group">
          <button v-if="portId>0" class="form-control btn btn-sm btn-danger" type="button" @click="removeP"><i class="fa fa-remove"></i></button>
        </div>
      </div>
    </div>
    <div class="row mb5">
      <div class="col-md-3">
        <strong
          v-if="groupData.length>0"
        >Indices (%): {{getFixed(groupData[groupData.length-1]-100)}}</strong>
      </div>
      <div class="col-md-3">
        <strong
          v-if="comPriceData.length>0"
        >Portfolio (%): {{getFixed(comPriceData[comPriceData.length-1]-100)}}</strong>
      </div>
      <div class="col-md-3" v-if="comPriceData.length>0">
        <!---v-if="comPriceData.length" --->
        <span v-for="(d, index) in duration" v-bind:key="d.id+d.name">
          <button
            type="button"
            @click="getDurationData(index)"
            class="btn btn-sm mb5"
            :class="(d.active)? 'btn-primary': 'btn-outline-secondary'"
            style="padding: 0.2rem;"
          >{{d.name}}</button>
        </span>
      </div>
    </div>
    <div class="row mb5">
      <div class="col-md-10" :id="'comp-portfolio'+portId">
        <canvas :id="'portfolios'"></canvas>
      </div>
    </div>
    <!-- <div class="row mb5" style="">
        <table :id="'portfolios-'+selComp.companyname" v-if="comPriceData.length>0">
          <thead><tr><td>Date</td><td>Index</td><td>Company Price</td></tr></thead>
          <tbody>
            <tr v-for="(fld, index) in groupLabels" :key="index+'-data'">
              <td>{{groupLabels[index]}}</td>
              <td>{{groupData[index]}}</td>
              <td>{{companyPrices[index]}}</td>
            </tr>
          </tbody>
        </table>
    </div>-->
    <div class="row mt15" v-if="selComp.co_code">
      <div class="col-md-4"></div>
      <div class="col-md-1">
        <download
          v-if="companyPrices.length>0"
          :tableId="selComp.co_code+'-'+priceVsIndexList[selInd].Group+'-actual'"
          :fileName="selComp.co_code+'-'+priceVsIndexList[selInd].Group+'-actual'"
        ></download>
      </div>
      <div class="col-md-1"></div>
      <div class="col-md-3"></div>
      <div class="col-md-1">
        <download
          v-if="companyPrices.length>0"
          :tableId="selComp.co_code+'-'+priceVsIndexList[selInd].Group+'-converted'"
          :fileName="selComp.co_code+'-'+priceVsIndexList[selInd].Group+'-converted'"
        ></download>
      </div>
      <div class="col-md-2"></div>
    </div>
    <div class="table-responsive mt15" v-dragscroll="true">
      <div class="row">
        <div class="col-md-5" v-if="comPriceData.length>0">
          <table
            class="table fonts11"
            :id="selComp.co_code+'-'+priceVsIndexList[selInd].Group+'-actual'"
          >
            <thead>
              <tr>
                <th>Date</th>
                <th>Actual Index</th>
                <th>Actual Company price</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(d, ind) in companyPrices[selComp.co_code]"
                v-if="ind >= startInd"
                :key="'actual'+ind"
              >
                <td>{{getDate(chartIndicesData.index.series[ind]["my_date"])}}</td>
                <td>{{chartIndicesData.index.series[ind]["value"]}}</td>
                <td>{{d[1]}}</td>
                <!-- <td>{{d}}</td> -->
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-5" v-if="comPriceData.length>0">
          <table
            class="table fonts11"
            :id="portId+selComp.co_code+'-'+priceVsIndexList[selInd].Group+'-converted'"
          >
            <thead>
              <tr>
                <th>Date</th>
                <th>Converted Index</th>
                <th>Converted Company price</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(d, ind) in groupData" :key="'conv'+ind">
                <td>{{getDate(compPriceLables[ind])}}</td>
                <td>{{groupData[ind]}}</td>
                <td>{{comPriceData[ind]}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- </div>
  </div>-->
  <!-- </card> -->
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "@/assets/mixins/common.js";

export default {
  mounted() {},
  mixins: [commonMixins],
  props: ["portId"],
  created() {
    console.log("portId", this.portId);
    this.getIndicesMaster();
  },
  data() {
    return {
      company: { co_code: "", companyname: "" },
      priceVsIndexList: [],
      selInd: "",
      companyList: [],
      selComp: "",
      groupLabels: [],
      groupData: [],
      compPriceLables: [],
      comPriceData: [],
      graphOptions: {
        maintainAspectRatio: true,
        legend: {
          display: true
        },
        scales: {
          xAxes: [
            {
              display: true
            }
          ],
          yAxes: [
            {
              // ticks: {
              //   beginAtZero: true
              // },
              display: true,
              gridLines: {
                zeroLineColor: "#e8e9ef",
                color: "#e8e9ef",
                drawBorder: true
              }
            }
          ]
        },
        elements: {
          line: {
            tension: 0.00001,
            borderWidth: 1
          },
          point: {
            radius: 1,
            hitRadius: 10,
            hoverRadius: 1,
            borderWidth: 2
          }
        }
      },
      companyPrices: [],
      isChartdataLoading: 0,
      duration: [
        { id: "1m", name: "1M", active: 0, duration: 0 },
        { id: "3m", name: "3M", active: 0, duration: 3 },
        { id: "6m", name: "6M", active: 0, duration: 6 },
        { id: "1y", name: "1Y", active: 0, duration: 12 },
        { id: "3Y", name: "3Y", active: 0, duration: 36 },
        { id: "5Y", name: "5Y", active: 0, duration: 60 },
        { id: "10Y", name: "10Y", active: 1, duration: 120 }
      ],
      selDur: 6,
      startInd: 0
    };
  },
  methods: {
    getPricevscomp() {
      let _this = this;
      http.get("getCompanyMaster", {}, function(error, response) {
        console.log("getIndustries Data", response);
        _this.companyList = response;
        if (_this.companyList.length > 0) {
          // if (!localStorage.getItem("selcomp")) {
          //   _this.selComp = _this.companyList[0];
          //   localStorage.setItem("selcomp", JSON.stringify(_this.selComp));
          // } else {
          //   _this.selComp = JSON.parse(localStorage.getItem("selcomp"));
          // }
          // _this.company.companyname = _this.selComp.companyname;
          // _this.company.co_code = _this.selComp.co_code;
          _this.getGroupData();
        }
      });
    },
    getIndicesMaster() {
      let _this = this;
      _this.priceVsIndexList = [];
      _this.selInd = "";
      http.get("getIndicesMaster", {}, function(error, response) {
        console.log("getIndices Data", response);
        _this.priceVsIndexList = response;
        if (_this.priceVsIndexList.length > 0) {
          _this.selInd = 0;
          _this.getPricevscomp();
          console.log("Selected Index ", _this.selInd);
        }
      });
    },
    getGroupData() {
      console.log(
        "Chartdata loading",
        this.isChartdataLoading,
        this.isChartdataLoading === 0
      );
      if (this.isChartdataLoading === 0) {
        (this.groupData = []),
          (this.groupLabels = []),
          (this.chartIndicesData = []);
        (this.comPriceData = []),
          (this.companyPrices = []),
          (this.compPriceLables = []);
        console.log(
          "this.selInd" + this.selInd + "====" + (this.selInd === "")
        );
        this.selDur = 6;
        this.startInd = 0;
        if (this.selInd !== "" && this.selComp !== "") {
          this.isChartdataLoading = 1;
          http.post(
            "getIndicesRatiosExchangeWise",
            {
              exchange: this.priceVsIndexList[this.selInd].Exchange,
              index_code: this.priceVsIndexList[this.selInd].indexcode,
              group: this.priceVsIndexList[this.selInd].Group,
              co_code: [this.selComp.co_code]
            },
            (error, response) => {
              this.isChartdataLoading = 0;
              console.log("chartdata", response);
              this.chartIndicesData = response;
              this.chartIndicesData.index.series.forEach((val, key) => {
                this.groupLabels.push(val["my_date"]); //.substring(0, val["my_date"].indexOf("T")));
                this.groupData.push(val["value"]);
              });
              this.groupData = this.getDataInRatio(this.groupData);
              console.log("GroupLabels", this.groupData, this.groupLabels);
              this.companyPrices = response.company_price;
              // localStorage.setItem("selcomp", JSON.stringify(this.selComp));
              response.company_price[this.selComp.co_code].forEach(
                (val, key) => {
                  this.compPriceLables.push(val[0]);
                  this.comPriceData.push(val[1]);
                }
              );
              this.comPriceData = this.getDataInRatio(this.comPriceData);
              // console.log(
              //   "this.comPriceData",
              //   this.comPriceData,
              //   this.compPriceLables
              // );
              this.plotGraph();
            }
          );
        } else {
          this.isChartdataLoading = 0;
          var emptyData =
            this.selInd === "" && this.selComp === ""
              ? "Indices & Company"
              : this.selInd === ""
              ? "Indices"
              : this.selComp === ""
              ? "Company"
              : "";
          this.$toastr.error("Please select " + emptyData, "", {
            positionClass: "topCenter"
          });
        }
      }
    },
    getCompPriceData() {
      if (this.selComp != "") {
        (this.comPriceData = []),
          (this.companyPrices = []),
          (this.compPriceLables = []);
        console.log("get comp prices");
        http.post(
          "rawDataList",
          { rowFieldName: historical_price, co_code: this.selComp.co_code },
          (error, response) => {
            console.log(response);
            if (response.data) {
              this.companyPrices = response.data[0].data;
              response.data[0].data.forEach((val, key) => {
                this.compPriceLables.push(
                  val.date.y(0, val.date.indexOf(" "))
                );
                this.comPriceData.push(val.Close);
              });
            }
            console.log(
              "this.comPriceData",
              this.comPriceData,
              this.compPriceLables
            );
            this.comPriceData = this.getDataInRatio(this.comPriceData);
            console.log("this.comPriceData", this.comPriceData);
            this.plotGraph();
          }
        );
      }
    },
    getDurationData(ind) {
      console.log(this.selInd, this.priceVsIndexList[this.selInd].Group);
      this.startInd = 0;
      this.duration[this.selDur].active = 0;
      this.duration[ind].active = 1;
      this.selDur = ind;
      var durDate = new Date();
      var curDate = new Date();
      durDate = this.minusMonths(
        new Date(curDate.getFullYear(), curDate.getMonth(), "01"),
        this.duration[ind].duration
      );
      console.log("durDate", durDate);
      this.getDataForDuration(curDate, durDate);
    },
    getDataForDuration(curDate, durDate) {
      (this.groupData = []), (this.groupLabels = []);
      console.log("this.selInd", this.selInd, this.chartIndicesData);
      this.chartIndicesData.index.series.forEach((val, key) => {
        var ddate = new Date(val["my_date"]);
        console.log(ddate, ddate > durDate, durDate);
        if (ddate > durDate) {
          if (this.startInd === 0) {
            this.startInd = key;
          }
          this.groupLabels.push(val["my_date"]);
          // this.groupLabels.push(val["my_date"].substring(0, val["my_date"].indexOf("T")));
          this.groupData.push(val["value"]);
        }
      });
      console.log("GroupLabels", this.groupData, this.groupLabels);
      this.groupData = this.getDataInRatio(this.groupData);
      console.log("GroupLabels", this.groupData, this.groupLabels);
      (this.comPriceData = []), (this.compPriceLables = []);
      this.companyPrices[this.selComp.co_code].forEach((val, key) => {
        var ddate = new Date(val[0]);
        // console.log(val, ddate, ddate > durDate, durDate);
        if (ddate > durDate) {
          this.compPriceLables.push(val[0]);
          this.comPriceData.push(val[1]);
        }
      });
      // console.log("this.comPriceData", this.comPriceData, this.compPriceLables);
      this.comPriceData = this.getDataInRatio(this.comPriceData);
      console.log("this.comPriceData", this.comPriceData);
      // this.plotGraph();
      this.configureChart();
    },
    plotGraph() {
      console.log("Plot Graph", this.selInd, this.selComp);
      if (this.selInd !== "" && this.selComp != "") {
        setTimeout(() => {
          this.configureChart();
        });
      }
    },
    configureChart() {
      // var ctx = document.getElementById("portfolio").getContext("2d");
      this.graphOptions["plugins"] = {
        datalabels: {
          display: false,
          align: "top",
          anchor: "end"
        }
      };
      var comPriceChartContent = document.getElementById("comp-portfolio"+this.portId);
      comPriceChartContent.innerHTML = "&nbsp;";
      var portId = this.portId;
      $("#comp-portfolio"+portId).append('<canvas id="portfolios'+portId+'"><canvas>');

      var ctx = $("#portfolios"+portId)
        .get(0)
        .getContext("2d");
      var chart = new Chart(ctx, {
        // The type of chart we want to create
        type: "line",
        // The data for our dataset
        data: {
          labels: this.groupLabels,
          datasets: [
            {
              label: "Index",
              backgroundColor: "transparent",
              borderColor: "rgb(81, 143, 212)",
              pointBackgroundColor: "#ffffff",
              data: this.groupData
            },
            {
              label: this.selComp.companyname,
              backgroundColor: "transparent",
              borderColor: "rgb(227, 175, 100)",
              pointBackgroundColor: "#ffffff",
              data: this.comPriceData
            }
          ]
        },
        // Configuration options go here
        options: this.graphOptions
      });
      chart.update();
    },
    removeP(){
      this.$emit("removePort", {portId: this.portId});
    },
  },
  mounted() {},
  watch: {}
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table th.column-sort {
  cursor: pointer;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/indices-data/companyVsIndices.vue